import React, { useEffect, useState } from "react";
import { Drawer } from "antd";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";
import server from "../../../server";
import { Button } from "antd/lib";
import "../../../styles/component/header-background-drawer.scss";
import ScrollPagination from "../../common/scroll-pagination/scroll-pagination";

interface IProps {
    open: boolean;
    onClose: () => void;
    onImageSelect: (url: string) => void;
    currImgUrl: string;
    onSubmit: () => void
}

interface Image {
    id: string;
    url: string;
    download_url: string;
}

const HeaderBackgroundDrawer: React.FC<IProps> = (props) => {

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [imgList, setImgList] = useState<Image[]>([]);
    const [selectedImg, setSelectedImg] = useState<string>('');
    const [pagination, setPagination] = useState({pageNumber: 0, pageSize: 30});

    useEffect(() => {
        fetchImages();
    }, []);


    useEffect(() => {
        setSelectedImg(props.currImgUrl);
    }, [props.currImgUrl]);

    async function fetchImages() {
        setIsLoading(true);
        try {
            const res = await server.utils.images.get(pagination.pageNumber, pagination.pageSize);
            setImgList(res)
        } catch (e) {
            console.log('error', e)
        } finally {
            setIsLoading(false);
        }
    }

    async function loadMoreImages() {
        setIsLoading(true);
        const nextPageNum = pagination.pageNumber + 1;
        try {

            const res = await server.utils.images.get(nextPageNum, pagination.pageSize);
            setImgList(prev => [...prev, ...res]);
        } catch (e) {
            console.log('error', e)
        } finally {
            setIsLoading(false);
            setPagination({
                pageNumber: nextPageNum,
                pageSize: 30
            })
        }
    }

    async function loadPrevImages() {
        setIsLoading(true);
        const prevPageNum = pagination.pageNumber - 1
        if (prevPageNum < 0) {
            setIsLoading(false);
            return;
        }

        try {
            const res = await server.utils.images.get(prevPageNum, pagination.pageSize);
            setImgList(prev => [...res, ...prev]);
        } catch (e) {
            console.log('error', e)
        } finally {
            setIsLoading(false);
            setPagination({
                pageNumber: prevPageNum,
                pageSize: 30
            })
        }
    }


    const DrawerTitle = () => (
        <div className={'dashboard-header-drawer__heading'}>
            <h4 className={'dashboard-header-drawer__title'}>
                Customize dashboard
            </h4>
            <p className={'dashboard-header-drawer__description'}>
                Change the background for this header
            </p>
        </div>

    )

    const imgExistsInList = Boolean(imgList.find((item) => item.download_url === props.currImgUrl));

    return (
        <Drawer
            rootClassName={'dashboard-header-drawer__wrapper'}
            title={<DrawerTitle/>}
            className={'dashboard-header-drawer'}
            onClose={props.onClose}
            open={props.open}
            extra={<Button
                type="primary"
                onClick={() => {
                    props.onSubmit();
                    props.onClose();
                }}
            >
                Apply
            </Button>}
        >
            <ScrollPagination
                isLoading={isLoading}
                loadNext={loadMoreImages}
                loadPrevious={loadPrevImages}
                hasNext={true}
                hasPrevious={pagination.pageNumber > 0}
                className={'dashboard-header-drawer__list-wrapper'}
            >
                <div className={'dashboard-header-drawer__list'}>
                    {!imgExistsInList && props.currImgUrl &&
                    <div className={`dashboard-header-drawer__item ${props.currImgUrl === selectedImg ?
                        'selected' : ''}`}
                         onClick={() => {
                             setSelectedImg(props.currImgUrl);
                             props.onImageSelect(props.currImgUrl);
                         }}
                    >
                        <img src={props.currImgUrl} alt="Dashboard background"
                             className={'dashboard-header-drawer__img'}/>
                    </div>}
                    {imgList.map((item) => {
                        const isSelected = item.download_url === selectedImg;
                        return (
                            <div
                                key={item.id}
                                className={`dashboard-header-drawer__item ${isSelected ? 'selected' : ''}`}
                                onClick={() => {
                                    setSelectedImg(item.download_url);
                                    props.onImageSelect(item.download_url);
                                }}
                            >
                                <img src={item.download_url} alt="Dashboard background"
                                     className={'dashboard-header-drawer__img'}/>
                            </div>
                        )
                    })
                    }
                </div>
            </ScrollPagination>
        </Drawer>
    )
}

export default HeaderBackgroundDrawer;
